import { useIntl } from '@/intl'
import { LazyImage } from '@/scopes/common/components/Image'
import * as React from 'react'
import { styled } from 'styled-components'

interface ProductCardImageProps {
  href: string
  src: string
}

const ImageLink = styled.a`
  flex-basis: 100%;
  flex-shrink: 0;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  text-decoration: none;
`

export function ProductCardImage({ href, src }: ProductCardImageProps) {
  const intl = useIntl()
  return (
    <ImageLink href={href} tabIndex={-1} aria-hidden target="_blank">
      <LazyImage
        src={src || ''}
        srcSet={[520, 600, 750, 960]}
        sizes="(min-width: 600px) 255px, (min-width: 840px) 375px, 100vw"
        fallbackText={intl.formatMessage({
          id: 'failed_to_load_image',
        })}
      />
    </ImageLink>
  )
}
